import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import LandingPage from './components/LandingPage';
import Login from './components/login/Login';
import PrivacyPolicy from './components/privacy/PrivacyPolicy';
import Dashboard from './components/dashboard/Dashboard';
import GetStarted from './components/dashboard/tabs/GetStarted';
import ApiKey from './components/dashboard/tabs/ApiKey';
import Ontology from './components/dashboard/tabs/Ontology';
import KnowledgeBase from './components/dashboard/tabs/KnowledgeBase';
import Profile from './components/dashboard/tabs/Profile';
import ProtectedRoute from './components/auth/ProtectedRoute';
import Playground from './components/playground/Playground';
// import InvestorsApp from './components/investors/InvestorsApp';
// import './components/investors/investors.css';

const A1CAIApp = () => {
  return (
    <Router>
      <Routes>
        {/* <Route path="/investors" element={<InvestorsApp />} /> */}
        <Route path="/" element={<LandingPage />} />
        <Route path="/login" element={<Login />} />
        <Route path="/privacy" element={<PrivacyPolicy />} />
        <Route 
          path="/playground"
          element={
            <ProtectedRoute>
              <Playground />
            </ProtectedRoute>
          }
        />
        <Route 
          path="/dashboard" 
          element={
            <ProtectedRoute>
              <Dashboard />
            </ProtectedRoute>
          }
        >
          <Route index element={<GetStarted />} />
          <Route path="api-key" element={<ApiKey />} />
          <Route path="ontology" element={<Ontology />} />
          <Route path="knowledge-base" element={<KnowledgeBase />} />
          <Route path="profile" element={<Profile />} />
        </Route>
        <Route path="*" element={<Navigate to="/" />} />
      </Routes>
    </Router>
  );
};

export default A1CAIApp; 